<template>
  <div class="row mb-3">

    <div class="col-sm-12">
      <div class="card mb-3">
        <div class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
        </div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="addItem">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">

              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">Name</label>
                <input type="text" v-model="nitem.name"  name="name" id="firstName" class="form-control" v-validate="{ required: true }">
                <span class="inputError">{{ errors.first('name') }}</span>
              </div>

              <div class="col-md-6">
                <label for="numericMeasure" class="form-label">numericMeasure</label>
                <input type="text" v-model.number="nitem.numericMeasure"  name="numericMeasure" id="numericMeasure" class="form-control" v-validate="{ required: true }">
                <span class="inputError">{{ errors.first('numericMeasure') }}</span>
              </div>

            </div>
            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Save
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'

export default {
  name: 'UserCreate',
  data() {
    return {
      nitem: {
        name: "",
        numericMeasure: 0
      },
      loading: false,
    }
  },
  methods: {
    async addItem() {

      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.post(this.$store.getters.getUrl + "/ChoiceValues", this.nitem).then(() => {
          this.$toast.success("Added", {
              position: "top-right"
            })
            this.loading = false
            this.$router.back()
        }).catch((e) => {
          this.$toast.error(e.response.data.title, {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Cells are not filled correctly. Check the boxes again!", {
          position: "top-right"
        })
        this.loading = false
      }
    },

    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
}
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}
</style>